module.exports = __webpack_public_path__ + "img/volume_up.6720af5a.svg";